var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close_FILL0_wght300_GRAD0_opsz20 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.0626 14.7116L5.28857 13.9376L9.22607 10.0001L5.28857 6.0626L6.0626 5.28857L10.0001 9.22607L13.9376 5.28857L14.7116 6.0626L10.7741 10.0001L14.7116 13.9376L13.9376 14.7116L10.0001 10.7741L6.0626 14.7116Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.217439997e46acf88423893743a28a45.svg";
export { ForwardRef as ReactComponent };